import { UserAvatar } from '_common/components';
import styles from './Table.module.scss';
import { Detail } from '@ets/design-system';

type EmailAddressCellProps = {
  user: UserPublicProfileExtended;
  userProfile: Profile;
};

const EmailAddressCell = ({ user, userProfile }: EmailAddressCellProps) => {
  return (
    <div className={`${styles.align} ${styles.email} ${!user.is_active && styles.deactivated}`}>
      <div className={styles.avatar} data-testid={`email-column-avatar-user-${user.id}`}>
        <UserAvatar userId={user.id} margin="0 1rem 0 0" userProfile={userProfile} />
      </div>
      <Detail weight="500" className={styles.ellipsis}>
        {user.email}
      </Detail>
    </div>
  );
};

export default EmailAddressCell;
